import React from "react";

export default function NotificationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1 1.25C7.70442 1.25 5.07724 4.22603 5.49841 7.59536L5.57776 8.23021C5.69388 9.15916 5.35455 10.0871 4.66654 10.7219C3.24086 12.0375 2.84477 14.1315 3.69142 15.8769L3.79477 16.09C4.58394 17.7169 6.23324 18.75 8.04147 18.75H16.2623C17.822 18.75 19.2736 17.9532 20.1111 16.6373C21.2932 14.7799 20.9801 12.3432 19.3668 10.845L19.3229 10.8042C18.5844 10.1183 18.2208 9.11912 18.3458 8.11901L18.4104 7.60208C18.832 4.22918 16.202 1.25 12.8029 1.25H11.1Z"
        fill="#A6B0CF"
      />
      <path
        d="M9.78339 20.55C9.53486 20.2186 9.06476 20.1515 8.73339 20.4C8.40202 20.6485 8.33487 21.1186 8.58339 21.45L8.88339 21.85C10.5334 24.05 13.8334 24.05 15.4834 21.85L15.7834 21.45C16.0319 21.1186 15.9648 20.6485 15.6334 20.4C15.302 20.1515 14.8319 20.2186 14.5834 20.55L14.2834 20.95C13.2334 22.35 11.1334 22.35 10.0834 20.95L9.78339 20.55Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
